import React, { useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";

const RedirectHandler = ({
  redirectUrl = "https://app.trilodocs.com/",
  message = "You are currently in a test environment. Redirecting to production...",
}) => {
  useEffect(() => {
    const toastId = toast.info(
      <div className="redirect-message">
        <div className="redirect-message__content">
          <span>{message}</span>
        </div>
      </div>,
      {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      }
    );

    const redirectTimer = setTimeout(() => {
      toast.dismiss(toastId);
      window.location.href = redirectUrl;
    }, 5000);

    return () => {
      clearTimeout(redirectTimer);
      toast.dismiss(toastId);
    };
  }, [redirectUrl]);

  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss={false}
      draggable
      pauseOnHover
      theme="light"
    />
  );
};

export default RedirectHandler;
